import { render, staticRenderFns } from "./ExerciseList.vue?vue&type=template&id=2eb15f30&"
import script from "./ExerciseList.vue?vue&type=script&lang=js&"
export * from "./ExerciseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports